import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const TerritoryProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'Territory', method: 'GET', secure: true });
    }, [execute]);  

    const listTerritoryTypes = useCallback(async () => {
        await execute({ scope: 'listTerritoryTypes', url: 'TerritoryType', method: 'GET', secure: true });
    }, [execute]);  

    const listTerritoryByFranchise = useCallback(async (props) => {
        await execute({ scope: 'listFranchiseTerritories', url: `Territory/Franchise/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const listZipcodesByState = useCallback(async (props) => {
        await execute({ scope: 'listZipcodesState', url: `Territory/Zipcode/State/${props.stateId}`, method: 'GET', secure: true });
    }, [execute]);  

    const listZipcodesByStates = useCallback(async (props) => {
        await execute({ scope: 'listZipcodesStates', url: `Territory/Zipcode/States/${props.states}`, method: 'GET', secure: true });
    }, [execute]);  

    const listZipcodesByFranchise = useCallback(async (props) => {
        await execute({ scope: 'listZipcodesFranchise', url: `Territory/Zipcode/Franchise/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);   

    const listZipcodesByFranchises = useCallback(async (props) => {
        await execute({ scope: 'listZipcodesFranchises', url: `Territory/Zipcode/Franchises/${props.franchiseIds}`, method: 'GET', secure: true });
    }, [execute]);   

    const deleteZipCodeTerritory = useCallback(async (props) => {
        await execute({ scope: 'deleteZipCodeTerritory', url: `Territory/${props.zipId}`, method: 'DELETE', secure: true });
    }, [execute]);  

    const addZipCodeTerritory = useCallback(async (props) => {
        await execute({ scope: 'addZipCodeTerritory', url: `Territory/`, method: 'PUT',  payload: props, secure: true });

        // {
        //     "territoryTypeId": "1",
        //     "zipCodes": [
        //         "91031"
        //     ],
        //     "ignore_whitespace": false,
        //     "franchiseId": 298,
        //     "branchOfficeId": 199,
        //     "forceUpdate": true,
        //     "forBranchOffice": true
        // }
    }, [execute]);  

    const zipCodeCheck = useCallback(async (props) => {
        await execute({ scope: 'zipCodeCheck', url: `Territory/ZipCodeCheck/`, method: 'POST', payload: props, secure: true });

        // {
        //     "territoryTypeId": "1",
        //     "zipCodes": [
        //         "91031"
        //     ],
        //     "ignore_whitespace": false,
        //     "franchiseId": 298,
        //     "branchOfficeId": 199,
        //     "forBranchOffice": true
        // }
    }, [execute]); 
    
    const listZipcodesByOffice = useCallback(async (props) => {
        await execute({ scope: 'listZipcodesOffice', url: `Territory/BranchOffice/${props.officeId}`, method: 'GET', secure: true });
    }, [execute]); 
    


    const value = { listRecords, listTerritoryTypes,listTerritoryByFranchise, listZipcodesByFranchise, listZipcodesByFranchises, listZipcodesByState, listZipcodesByStates, listZipcodesByOffice, deleteZipCodeTerritory, addZipCodeTerritory, zipCodeCheck, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useTerritoryStore = () => React.useContext(Context);
